/* RESPONSIBLE TEAM: team-inbox-management */
import ApplicationAdapter from '../application';

export default class DomainObjectInstanceAdapter extends ApplicationAdapter {
  pathForType() {
    return 'domain_objects';
  }
}
